import React from "react";

const termsHTML = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Terms of Service — ELDE</title>
  <link href="https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:wght@300;400;500;600&display=swap" rel="stylesheet" />
  <style>
    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

    :root {
      --dark: #0f0f1a;
      --navy: #1a1a2e;
      --blue: #4F7FFA;
      --cyan: #00BCD4;
      --text: #1a1a2e;
      --muted: #64748b;
      --border: #e2e8f0;
      --bg: #f8fafc;
    }

    body {
      font-family: 'DM Sans', sans-serif;
      background: var(--bg);
      color: var(--text);
      line-height: 1.7;
    }

    header {
      background: var(--navy);
      padding: 20px 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .logo {
      display: inline-flex;
      align-items: center;
      border: 2px solid var(--cyan);
      border-radius: 6px;
      padding: 3px 10px;
      text-decoration: none;
    }
    .logo-el { font-family: 'DM Serif Display', serif; font-size: 20px; color: #fff; letter-spacing: 2px; }
    .logo-de { font-family: 'DM Serif Display', serif; font-size: 20px; color: var(--cyan); letter-spacing: 2px; }

    .hero {
      background: linear-gradient(135deg, var(--navy) 0%, #1e2a4a 100%);
      padding: 72px 24px 56px;
      text-align: center;
      position: relative;
      overflow: hidden;
    }
    .hero::before {
      content: '';
      position: absolute;
      inset: 0;
      background-image: linear-gradient(rgba(79,127,250,0.06) 1px, transparent 1px),
                        linear-gradient(90deg, rgba(79,127,250,0.06) 1px, transparent 1px);
      background-size: 40px 40px;
    }
    .hero-badge {
      display: inline-block;
      background: rgba(79,127,250,0.15);
      border: 1px solid rgba(79,127,250,0.3);
      color: #93b4ff;
      font-size: 12px;
      font-weight: 600;
      letter-spacing: 1.5px;
      text-transform: uppercase;
      padding: 5px 14px;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;
    }
    .hero h1 {
      font-family: 'DM Serif Display', serif;
      font-size: clamp(36px, 6vw, 56px);
      color: #fff;
      line-height: 1.15;
      margin-bottom: 16px;
      position: relative;
    }
    .hero-sub {
      color: #8899bb;
      font-size: 16px;
      position: relative;
    }

    .container {
      max-width: 760px;
      margin: 0 auto;
      padding: 64px 24px;
    }

    .toc {
      background: #fff;
      border: 1px solid var(--border);
      border-radius: 16px;
      padding: 28px 32px;
      margin-bottom: 48px;
      box-shadow: 0 1px 4px rgba(0,0,0,0.05);
    }
    .toc-title {
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 1.5px;
      text-transform: uppercase;
      color: var(--muted);
      margin-bottom: 14px;
    }
    .toc ol { padding-left: 18px; }
    .toc li { margin-bottom: 6px; }
    .toc a { color: var(--blue); text-decoration: none; font-size: 14px; font-weight: 500; }
    .toc a:hover { text-decoration: underline; }

    section { margin-bottom: 48px; }

    .section-num {
      display: inline-block;
      background: var(--blue);
      color: #fff;
      font-size: 11px;
      font-weight: 700;
      width: 24px;
      height: 24px;
      border-radius: 6px;
      text-align: center;
      line-height: 24px;
      margin-right: 10px;
      vertical-align: middle;
    }

    h2 {
      font-family: 'DM Serif Display', serif;
      font-size: 24px;
      color: var(--text);
      margin-bottom: 16px;
      padding-top: 8px;
      border-top: 2px solid var(--border);
    }
    h3 {
      font-size: 15px;
      font-weight: 600;
      color: var(--text);
      margin: 20px 0 8px;
    }
    p {
      font-size: 15px;
      color: #374151;
      margin-bottom: 14px;
    }
    ul {
      padding-left: 20px;
      margin-bottom: 14px;
    }
    li {
      font-size: 15px;
      color: #374151;
      margin-bottom: 6px;
    }

    .highlight {
      background: linear-gradient(135deg, #EEF2FF, #E0F2FE);
      border: 1px solid #C7D2FE;
      border-radius: 12px;
      padding: 18px 20px;
      margin: 20px 0;
      font-size: 14px;
      color: #1e3a5f;
    }
    .highlight strong { color: var(--blue); }

    .warning {
      background: #FFF7ED;
      border: 1px solid #FED7AA;
      border-radius: 12px;
      padding: 18px 20px;
      margin: 20px 0;
      font-size: 14px;
      color: #7c2d12;
    }

    .contact-card {
      background: var(--navy);
      border-radius: 16px;
      padding: 28px 32px;
      color: #fff;
      margin-top: 48px;
    }
    .contact-card h2 {
      color: #fff;
      border-top-color: rgba(255,255,255,0.1);
      font-family: 'DM Serif Display', serif;
    }
    .contact-card p { color: #8899bb; }
    .contact-card a { color: var(--cyan); text-decoration: none; font-weight: 600; }

    footer {
      text-align: center;
      padding: 32px 24px;
      border-top: 1px solid var(--border);
      font-size: 13px;
      color: var(--muted);
    }

    @media (max-width: 600px) {
      .container { padding: 40px 16px; }
      .toc { padding: 20px; }
    }
  </style>
</head>
<body>

<header>
  <a href="javascript:history.back()" class="logo">
    <span class="logo-el">EL</span><span class="logo-de">DE</span>
  </a>
  <span style="color: #8899bb; font-size: 13px;">Terms of Service</span>
</header>

<div class="hero">
  <div class="hero-badge">Legal</div>
  <h1>Terms of Service</h1>
  <p class="hero-sub">Last updated: LAST_UPDATED_DATE</p>
</div>

<div class="container">

  <div class="highlight">
    <strong>The short version:</strong> ELDE is a personal finance tool to help you track and pay off debt. Use it honestly, keep your account secure, and don't misuse the service. We provide it as-is and are not financial advisors.
  </div>

  <div class="toc">
    <div class="toc-title">Table of Contents</div>
    <ol>
      <li><a href="#acceptance">Acceptance of Terms</a></li>
      <li><a href="#description">Description of Service</a></li>
      <li><a href="#accounts">User Accounts</a></li>
      <li><a href="#use">Acceptable Use</a></li>
      <li><a href="#financial">No Financial Advice</a></li>
      <li><a href="#ai">AI Features</a></li>
      <li><a href="#data">Your Data</a></li>
      <li><a href="#payments">Payments & Subscriptions</a></li>
      <li><a href="#termination">Termination</a></li>
      <li><a href="#disclaimers">Disclaimers & Liability</a></li>
      <li><a href="#changes">Changes to Terms</a></li>
      <li><a href="#contact">Contact</a></li>
    </ol>
  </div>

  <section id="acceptance">
    <h2><span class="section-num">1</span> Acceptance of Terms</h2>
    <p>By creating an account or using ELDE ("the Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the Service.</p>
    <p>These Terms apply to all users of ELDE, including visitors, registered users, and premium subscribers.</p>
  </section>

  <section id="description">
    <h2><span class="section-num">2</span> Description of Service</h2>
    <p>ELDE is a personal debt tracking and payoff planning application. The Service allows users to:</p>
    <ul>
      <li>Manually track debt accounts, balances, and interest rates</li>
      <li>Plan and simulate debt payoff strategies</li>
      <li>Log and monitor payment history</li>
      <li>Earn milestone achievements for debt progress</li>
      <li>Receive AI-powered financial coaching suggestions via the Ellie advisor</li>
    </ul>
    <p>ELDE does <strong>not</strong> connect to bank accounts, process payments, or access real financial institutions.</p>
  </section>

  <section id="accounts">
    <h2><span class="section-num">3</span> User Accounts</h2>
    <h3>Registration</h3>
    <p>You must create an account to use ELDE. You agree to provide accurate, current, and complete information during registration and to keep your account information updated.</p>

    <h3>Account Security</h3>
    <p>You are responsible for maintaining the confidentiality of your password and for all activities that occur under your account. You agree to notify us immediately at <a href="/cdn-cgi/l/email-protection#f3969f9796dd808683839c8187b3949e929a9fdd909c9e" style="color: var(--blue);"><span class="__cf_email__" data-cfemail="a6c3cac2c388d5d3d6d6c9d4d2e6c1cbc7cfca88c5c9cb">[email&#160;protected]</span></a> of any unauthorized use of your account.</p>

    <h3>One Account Per User</h3>
    <p>Each user may maintain only one account. Creating multiple accounts to circumvent limitations or policies is prohibited.</p>

    <h3>Age Requirement</h3>
    <p>You must be at least 13 years old to use ELDE. By using the Service, you represent that you meet this age requirement.</p>
  </section>

  <section id="use">
    <h2><span class="section-num">4</span> Acceptable Use</h2>
    <p>You agree not to use ELDE to:</p>
    <ul>
      <li>Violate any applicable laws or regulations</li>
      <li>Impersonate any person or entity</li>
      <li>Attempt to gain unauthorized access to our systems</li>
      <li>Interfere with or disrupt the Service</li>
      <li>Reverse engineer, decompile, or attempt to extract source code</li>
      <li>Use automated tools to scrape or access the Service</li>
      <li>Share your account credentials with others</li>
    </ul>
  </section>

  <section id="financial">
    <h2><span class="section-num">5</span> No Financial Advice</h2>
    <div class="warning">
      <strong>Important:</strong> ELDE is a personal organization tool, not a licensed financial advisor. Nothing in the app constitutes financial, legal, tax, or investment advice.
    </div>
    <p>The payoff calculations, strategy suggestions, and AI advisor responses provided by ELDE are for informational and planning purposes only. They are based solely on the data you enter and should not be relied upon as professional financial advice.</p>
    <p>We strongly recommend consulting a qualified financial advisor for personalized financial guidance, especially for significant financial decisions.</p>
    <p>ELDE makes no guarantees about the accuracy of calculations or projections. Actual results may vary based on interest rate changes, fees, and other factors not accounted for in the app.</p>
  </section>

  <section id="ai">
    <h2><span class="section-num">6</span> AI Features</h2>
    <p>ELDE includes an AI-powered advisor ("Ellie") powered by Anthropic's Claude API. By using this feature:</p>
    <ul>
      <li>You acknowledge that AI responses may not always be accurate or appropriate for your situation</li>
      <li>You agree that AI suggestions do not constitute professional financial advice</li>
      <li>You understand that your data is sent to Anthropic's API to generate responses</li>
      <li>You accept Anthropic's <a href="https://www.anthropic.com/legal/consumer-terms" style="color: var(--blue);">Terms of Service</a> as applicable to AI-generated content</li>
    </ul>
  </section>

  <section id="data">
    <h2><span class="section-num">7</span> Your Data</h2>
    <h3>Ownership</h3>
    <p>You retain full ownership of all financial data you enter into ELDE. We do not claim any rights to your data.</p>

    <h3>License to Operate</h3>
    <p>By using ELDE, you grant us a limited license to store, process, and display your data solely for the purpose of providing the Service to you.</p>

    <h3>Deletion</h3>
    <p>You may delete your account and all associated data at any time through the app. Upon deletion, your data is permanently removed from our systems and cannot be recovered.</p>

    <h3>Data Accuracy</h3>
    <p>You are responsible for the accuracy of the data you enter. ELDE is not responsible for errors in calculations resulting from incorrect data entry.</p>
  </section>

  <section id="payments">
    <h2><span class="section-num">8</span> Payments & Subscriptions</h2>
    <p>ELDE offers both free and premium tiers. If you subscribe to a premium plan:</p>
    <ul>
      <li>Subscription fees are charged in advance on a monthly or annual basis</li>
      <li>Subscriptions automatically renew unless cancelled before the renewal date</li>
      <li>Refunds are handled on a case-by-case basis — contact us within 7 days of a charge if you believe you were billed in error</li>
      <li>Prices may change with 30 days advance notice</li>
      <li>Cancelling a subscription downgrades your account to the free tier at the end of the billing period</li>
    </ul>
    <p>For App Store purchases, Apple's refund policies apply. For web purchases, contact us at <a href="/cdn-cgi/l/email-protection#46232a2223683533363629343206212b272f2a6825292b" style="color: var(--blue);"><span class="__cf_email__" data-cfemail="bedbd2dadb90cdcbceced1cccafed9d3dfd7d290ddd1d3">[email&#160;protected]</span></a>.</p>
  </section>

  <section id="termination">
    <h2><span class="section-num">9</span> Termination</h2>
    <h3>By You</h3>
    <p>You may stop using the Service and delete your account at any time through the app settings.</p>

    <h3>By Us</h3>
    <p>We reserve the right to suspend or terminate accounts that violate these Terms, engage in abusive behavior, or for any other reason at our discretion. We will attempt to provide notice before termination where possible.</p>

    <h3>Effect of Termination</h3>
    <p>Upon termination, your right to use the Service ceases immediately. Your data will be deleted in accordance with our Privacy Policy.</p>
  </section>

  <section id="disclaimers">
    <h2><span class="section-num">10</span> Disclaimers & Limitation of Liability</h2>
    <h3>Service Provided "As Is"</h3>
    <p>ELDE is provided on an "as is" and "as available" basis without warranties of any kind, either express or implied. We do not warrant that the Service will be uninterrupted, error-free, or completely secure.</p>

    <h3>Limitation of Liability</h3>
    <p>To the maximum extent permitted by law, ELDE and its creators shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of or inability to use the Service, including but not limited to:</p>
    <ul>
      <li>Loss of data</li>
      <li>Financial losses based on app calculations</li>
      <li>Decisions made based on AI advisor suggestions</li>
      <li>Service interruptions or downtime</li>
    </ul>
    <p>Our total liability to you for any claims arising from these Terms or your use of the Service shall not exceed the amount you paid us in the 12 months preceding the claim.</p>
  </section>

  <section id="changes">
    <h2><span class="section-num">11</span> Changes to Terms</h2>
    <p>We may update these Terms of Service from time to time. We will notify you of material changes by email or through a prominent notice in the app at least 14 days before changes take effect.</p>
    <p>Your continued use of ELDE after changes take effect constitutes your acceptance of the revised Terms.</p>
  </section>

  <div class="contact-card" id="contact">
    <h2><span class="section-num" style="background: var(--cyan); color: var(--navy);">12</span> Contact</h2>
    <p>Questions about these Terms? We're happy to help.</p>
    <p style="margin-top: 12px;">
      <strong style="color: #fff;">Email:</strong> <a href="/cdn-cgi/l/email-protection#583d343c3d762b2d2828372a2c183f35393134763b3735"><span class="__cf_email__" data-cfemail="24414840410a575154544b5`;

export default function Terms() {
  const now = new Date();
  const date = now.toLocaleDateString("en-US", { month: "long", year: "numeric" });
  const html = termsHTML.replace("LAST_UPDATED_DATE", date);
  return (
    <div
      dangerouslySetInnerHTML={{ __html: html }}
      style={{ all: "initial", display: "block" }}
    />
  );
}
